import { onBeforeUnmount, onMounted, type Ref } from 'vue';

export function useBeforeUnloadWarning(hasUnsavedChanges: Ref<boolean>): void {
  const handler = (event: BeforeUnloadEvent): void => {
    if (!hasUnsavedChanges.value) return;
    event.preventDefault();
    event.returnValue = '';
  };

  onMounted(() => {
    if (typeof window === 'undefined') return;
    window.addEventListener('beforeunload', handler);
  });

  onBeforeUnmount(() => {
    if (typeof window === 'undefined') return;
    window.removeEventListener('beforeunload', handler);
  });
}
